@if (!disabled) {
  @let dateGroupValue = dateComponent?.group?.value;
  <div class="datetime-container">
    <app-template-date [control]="group.controls.date" [value]="dateValue" [required]="required" [characters]="characters" [showClear]="false" />
    <app-template-time [control]="group.controls.time" [value]="timeValue" [required]="required" [characters]="characters" [showClear]="false" />
    <button
      class="clear-button"
      type="button"
      (click)="clear()"
      [disabled]="!dateGroupValue?.date && !dateGroupValue?.month && !dateGroupValue?.year && !group.controls.time.value"
    >
      <mat-icon>backspace</mat-icon>
    </button>
  </div>
} @else {
  <app-template-html [control]="control" [label]="label" [value]="value" />
}
